// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getItem = (storage: any, key: string, defaultValue: string): string => {
  if (storage) {
    const item = storage.getItem(key)
    return item === null ? defaultValue : item
  }
  return defaultValue
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setItem = (storage: any, key: string, value: string): void => storage && storage.setItem(key, value)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const removeItem = (storage: any, key: string): void => storage && storage.removeItem(key)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const clearAll = (storage: any): void => storage && storage.clear()
